module.exports = __webpack_public_path__ + "img/westudy_constructor.ac4713e1.png";